import type { Context } from "./context";
import type { RoutePathArguments } from "./route-path";


export type Handler<
    T extends RoutePathArguments = RoutePathArguments,
    C extends Context<T> = Context<T>,
> = (context: C) => boolean | void | Promise<boolean | void>;
